import type { NestedKeysStripped } from '@payloadcms/translations';
import { daTranslations } from '@payloadcms/translations/languages/da';
import { enTranslations } from '@payloadcms/translations/languages/en';

export const customTranslations = {
  da: {
    admin: {
      aiAltText: {
        generate: 'Generer',
        generating: 'Generere...',
        generated: 'Genereret',
        error: 'Der opstod en fejl under generering af alt tekst',
        noUrl: 'Mediet har ingen URL. Generering af alt tekst er ikke muligt.',
      },
    },
    blog: {
      articles: 'Artikler',
      name: 'Viden',
      latestArticles: 'Seneste artikler',
      relatedArticles: 'Relaterede artikler',
      searchField: 'Søg i viden',
      viewAll: 'Se flere af vores artikler',
    },
    careers: {
      name: 'Karrierer',
      singleName: 'Karriere',
      vacancies: 'Ledige jobs',
      jobs: 'Jobs',
    },
    cases: {
      name: 'Cases',
      searchField: 'Søg i cases',
      singleName: 'Case',
      viewAll: 'Se alle cases',
    },
    close: 'Luk',
    copied: 'Kopieret',
    copy: 'Kopier',
    employee: {
      connectOnLinkedIn: 'Forbind på LinkedIn',
      contact: 'Kontakt',
      searchField: 'Søg efter medarbejder, lokation osv.',
      vacancies: 'Ledige stillinger',
    },
    events: {
      canAlsoBeExperiencedOnline: 'Kan også opleves online',
      canAlsoBeExperiencedIn: 'Kan også opleves i',
      currentRightNow: 'Aktuelt lige nu',
      dateAndTime: 'Dato & tidspunkt',
      followOnLinkedIn: 'Følg',
      goToEvent: 'Gå til event',
      location: 'Lokation',
      name: 'Events',
      online: 'Online',
      price: 'Pris',
      searchField: 'Søg i events',
      signup: 'Tilmeld',
      singleName: 'Event',
      speakers: 'Speakers',
      thankYouForToday: 'Tak for i dag',
      todaysAgenda: 'Dagens agenda',
      viewAll: 'Se alle events',
    },
    techs: {
      name: 'Teknologier',
      searchField: 'Søg i teknologier',
      singleName: 'Teknologi',
      viewAll: 'Se alle teknologier',
    },
    filters: {
      all: 'Alle',
      label: 'Filter',
    },
    loadAllButton: {
      showAll: 'Vis alle',
      showing: 'Viser',
    },
    next: 'Næste',
    of: 'af',
    previous: 'Forrige',
    readingTime: 'Læsetid',
    search: 'Søg',
    goTo: 'Gå til',
    profile: 'profil',
    goToFrontpage: 'Gå til forsiden',
  },
  en: {
    admin: {
      aiAltText: {
        generate: 'Generate',
        generating: 'Generating...',
        generated: 'Generated',
        error: 'There was an error generating alt text',
        noUrl: 'Media has no URL. Generating alt text is not possible.',
      },
    },
    blog: {
      articles: 'Articles',
      name: 'Blog',
      latestArticles: 'Latest articles',
      relatedArticles: 'Related articles',
      searchField: 'Search blog',
      viewAll: 'View more articles',
    },
    careers: {
      name: 'Careers',
      singleName: 'Career',
      vacancies: 'Vacancies',
      jobs: 'Jobs',
    },
    cases: {
      name: 'Cases',
      searchField: 'Search cases',
      singleName: 'Case',
      viewAll: 'View all cases',
    },
    close: 'Close',
    copied: 'Copied',
    copy: 'Copy',
    employee: {
      connectOnLinkedIn: 'Connect on LinkedIn',
      contact: 'Contact',
      searchField: 'Search for employee, location etc.',
      vacancies: 'Vacancies',
    },
    events: {
      canAlsoBeExperiencedOnline: 'Can also be experienced online',
      canAlsoBeExperiencedIn: 'Can also be experienced in',
      currentRightNow: 'Current right now',
      dateAndTime: 'Date & time',
      followOnLinkedIn: 'Follow',
      goToEvent: 'Go to event',
      location: 'Location',
      name: 'Events',
      online: 'Online',
      price: 'Price',
      searchField: 'Search events',
      signup: 'Sign up',
      singleName: 'Event',
      speakers: 'Speakers',
      thankYouForToday: 'Thank you for today',
      todaysAgenda: "Today's agenda",
      viewAll: 'View all events',
    },
    techs: {
      name: 'Technologies',
      searchField: 'Search technologies',
      singleName: 'Technology',
      viewAll: 'View all technologies',
    },
    filters: {
      all: 'All',
      label: 'Filter',
    },
    loadAllButton: {
      showAll: 'Show all',
      showing: 'Showing',
    },
    next: 'Next',
    of: 'of',
    previous: 'Previous',
    readingTime: 'Reading time',
    search: 'Search',
    goTo: 'Go to',
    profile: 'profile',
    goToFrontpage: 'Go to frontpage',
  },
} as const;

export type CustomTranslationsEnObject = typeof customTranslations.en &
  typeof enTranslations;
export type CustomTranslationsDaObject = typeof customTranslations.da &
  typeof daTranslations;

export type CustomTranslationsEnKeys =
  NestedKeysStripped<CustomTranslationsEnObject>;
export type CustomTranslationsDaKeys =
  NestedKeysStripped<CustomTranslationsDaObject>;

export type CustomTranslationsObject =
  | CustomTranslationsEnObject
  | CustomTranslationsDaObject;

export type CustomTranslationsKeys =
  | CustomTranslationsEnKeys
  | CustomTranslationsDaKeys
  | keyof CustomTranslationsEnObject
  | keyof CustomTranslationsDaObject;
